<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">

                <persons-form :person="person" :loader="loader" @click="storePerson(person)" :showLabels="false"></persons-form>

            </div>
        </div>
    </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import personsApi from '../../api/persons'
  import personsForm from './Form.vue'
  import Person from '../../models/person'

  export default {

    components: {
      personsForm
    },
    data () {
      return {
        person: new Person(),
        loader: false
      }
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Inserisci nuova persona',
        createButton: {display: false}
      })
    },

    methods: {
      storePerson (person) {
        this.loader = true
        person.archive_id = this.$store.state.profile.profile.archive.data.id
        personsApi.store(person)
          .then((response) => {
            toastr.success('La persona è stata inserita correttamente')
            this.$router.push('/persons')
          })
          .catch((response) => {
            this.loader = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/persons/Create.vue